// Copied from the current original editor template-save dialog.
export const templateMarkup = `<dialog class="template-save-dialog" id="template-save-dialog">
            <form method="dialog" id="template-save-form">
                <button class="dialog-close" type="button" id="template-save-close" aria-label="Закрыть">×</button>
                <h2>Сохранить в шаблоны</h2>
                <p class="template-save-note">В шаблон попадут все экраны, объекты и интерактивные настройки текущего проекта.</p>
                <label>
                    Название
                    <input type="text" id="template-title" maxlength="160" required>
                </label>
                <label>
                    Описание
                    <textarea id="template-description" maxlength="2000" rows="4"></textarea>
                </label>
                <label>
                    Теги
                    <input type="text" id="template-tags" maxlength="500" placeholder="Счет, математика, начальная школа">
                    <small>Разделяйте теги запятыми.</small>
                </label>
                <label>
                    Свое превью (необязательно)
                    <input type="file" id="template-preview-file" accept="image/jpeg,image/png,image/webp,image/gif">
                    <small>Если файл не выбран, превью будет создано из текущего холста.</small>
                </label>
                <div class="template-save-actions">
                    <button type="button" id="template-save-cancel">Отмена</button>
                    <button type="submit" class="template-save-submit" id="template-save-submit">Сохранить шаблон</button>
                </div>
                <p class="form-error" id="template-save-error"></p>
            </form>
        </dialog>`;
